import { observer, use$ } from '@legendapp/state/react';
import {
  Button,
  type ButtonProps,
  type PolymorphicComponentProps,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useStartManualBet } from '../../../hooks';
import { manualBetState$ } from '../../../state';
export type ManualBetStartButtonProps = PolymorphicComponentProps<
  'button',
  ButtonProps
>;

export const ManualBetStartButton = observer(
  (props: ManualBetStartButtonProps) => {
    const isBetting = use$(manualBetState$.isBetting);
    const { t } = useTranslation();
    const {
      handleStartManualBet,
      mutation: { isPending },
    } = useStartManualBet();

    if (isBetting) {
      return null;
    }

    return (
      <Button
        fullWidth
        hidden={isBetting}
        loading={isPending}
        mt={12}
        onClick={handleStartManualBet}
        size="lg"
        {...props}
      >
        {t('manualBet.start')}
      </Button>
    );
  }
);
